import messages from '../messages';

const countyCountries = ['IE'];
const departmentCountries = ['HN', 'NI', 'SV', 'UY'];
const districtCountries = ['BS', 'BZ', 'KI', 'NR', 'SR'];
const prefectureCountries = ['JP'];
const provinceCountries = [
  'AR',
  'BY',
  'CA',
  'CN',
  'DO',
  'ID',
  'KN',
  'KR',
  'KZ',
  'MZ',
  'PA',
  'UA',
  'VN',
  'ZA',
];
const regionCountries = ['GB', 'IT', 'NZ', 'OM', 'PG', 'PH', 'SO', 'TH'];

const labelMapping = {
  addressLine: 'AddressLineLabel',
  addressLine1: 'AddressLine1Label',
  addressLine2: 'AddressLine2Label',
  city: 'CityLabel',
  country: 'CountryLabel',
  postalCode: 'PostalCodeLabel',
  stateProvince: 'AdministrativeAreaStateLabel',
};

const getStateProvinceLabelKey = (countryCode) => {
  if (countyCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaCountyLabel';
  }

  if (departmentCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaDepartmentLabel';
  }

  if (districtCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaDistrictLabel';
  }

  if (prefectureCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaPrefectureLabel';
  }

  if (provinceCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaProvinceLabel';
  }

  if (regionCountries.indexOf(countryCode) !== -1) {
    return 'AdministrativeAreaRegionLabel';
  }

  return 'AdministrativeAreaStateLabel';
};

/* eslint-disable import/prefer-default-export */
export const getDefaultLabels = (intl, countryCode) => {
  const { formatMessage } = intl;
  const labels = {};
  labelMapping.stateProvince = getStateProvinceLabelKey(countryCode);

  Object.keys(labelMapping).forEach((k) => {
    labels[k] = formatMessage(messages[labelMapping[k]]);
  });
  return labels;
};
